import React from "react";

import { fetchData } from "../services/api";
import { isClient } from "../styles/utils";
import { useIdentify } from "hooks/useIdentify";

export const SegmentIdentify = () => {
  useIdentify({
    autoTriggerIdentifyCalls: true,
  });

  return <></>;
};

export const segmentTrack = (event, data, config = {}) => {
  if (!isClient() || !window?.analytics) return;

  const { withReport, data: requestData } = config;

  const trackCall = (data) => {
    window.analytics.track(event, data);
  };

  if (withReport) {
    fetchData("/reports-analytics", { params: requestData }).then((res) => {
      if (res.success) {
        trackCall({
          ...res.data,
          ...data,
        });
      }
    });
  } else {
    trackCall({ ...data });
  }
};

export const segmentGroupTrack = (teamId, data) => {
  window.analytics.group(teamId, {
    ...data,
  });
};
